const querystring = require('querystring');
const isEmpty = require('lodash/isEmpty');

const removeEmptyItems = query => {
  const queryWithoutEmpties = {};

  Object.keys(query).forEach(key => {
    const value = query[key];
    if (!isEmpty(key) && !isEmpty(value)) {
      Object.assign(queryWithoutEmpties, { [key]: querystring.unescape(value) });
    }
  });

  return queryWithoutEmpties;
};

const convertPathParamsToQueryParams = path => {
  const query = querystring.parse(path, '/', '.');

  // Remove any empty object property due invalid path elements (due items that
  // contains more than one dot or path contains more than one slash)
  return removeEmptyItems(query);
};

const normalizeEmail = email =>
  // Patch for emails containing '+' charactes
  // The url by definition interprets '+' characters as spaces, so we need a
  // custom check for the email and any other fields containing '+'
  email.replace(/ /g, '+');

module.exports = {
  convertPathParamsToQueryParams,
  normalizeEmail,
};



// WEBPACK FOOTER //
// ./server/utils/params.js